// import { fragmentMoney } from "@saleor/fragments/products";
import gql from "graphql-tag";

import { pageInfoFragment } from "./pageInfo";

export const saleFragment = gql`
  fragment SaleFragment on Sale {
    id
    name
    type
    startDate
    endDate
    value
    status
    description
    isAppliedToAllStores
  }
`;

export const saleDetailsFragment = gql`
  ${pageInfoFragment}
  ${saleFragment}
  fragment SaleDetailsFragment on Sale {
    ...SaleFragment
    tenants(first: $first, last: $last) {
      edges {
        node {
          id
          legalName
          storeName
        }
      }
    }
    categories(first: $first, last: $last) {
      edges {
        node {
          id
          name
          products {
            totalCount
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
    collections(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          name
          products {
            totalCount
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
  }
`;

export const voucherFragment = gql`
  fragment VoucherFragment on Voucher {
    id
    code
    startDate
    endDate
    usageLimit
    description
    discountValueType
    discountValue
    countries {
      code
      country
    }
    maxDiscountValue
    minSpent {
      currency
      amount
    }
    minTenants
    status
    minCheckoutItemsQuantity
    verticalType
    type
  }
`;

export const voucherGroupFragment = gql`
  fragment VoucherGroupFragment on VoucherGroup {
    id
    code
    createdAt
    deletedAt
    updatedAt
    status
    createdBy {
      firstName
      lastName
    }
    status
    vouchers(after: $after, before: $before, first: $first, last: $last) {
      totalCount
      edges {
        node {
          id
          code
        }
      }
    }
  }
`;

export const voucherDetailsFragment = gql`
  ${pageInfoFragment}
  ${voucherFragment}
  fragment VoucherDetailsFragment on Voucher {
    ...VoucherFragment
    type
    code
    usageLimit
    used
    isLimitToNewCustomer
    applyOncePerOrder
    applyOncePerCustomer
    smopDiscountShare
    tenantDiscountShare
    malls(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          name
        }
      }
    }
    products(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          name
          productStatus
          productType {
            id
            name
          }
          isPublished
          thumbnail {
            url
          }
        }
      }
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
    }
    collections(first: $first, last: $last) {
      edges {
        node {
          id
          name
          products {
            totalCount
          }
        }
      }
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
    }
    categories(first: $first, last: $last) {
      edges {
        node {
          id
          name
          products {
            totalCount
          }
        }
      }

      totalCount
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export const voucherTenantFragment = gql`
  fragment VoucherTenantFragment on VoucherTenant {
    id
    smoDiscountShare
    tenantDiscountShare
    tenant {
      id
      tenantType
      mall {
        id
        name
      }
      brand {
        legalName
        name
        id
      }
    }
  }
`;
